module.exports = __webpack_public_path__ + "static/img/C4D0016.0e598bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0016.jpg
// module id = n+tL
// module chunks = 0